import type { WorkCalendar } from '@hana/work-calendar';
import { hm } from '../home/view';

// Dữ liệu mẫu chấm công điện thoại (board Mint-Checkin-Phone). Điểm làm việc / vị trí là dữ liệu mẫu, không gọi GPS / camera thật.
export type Group = 'office' | 'field';

export interface Site { name: string; radius: number; addr: string }
export const OFFICE: Site = { name: 'VP HANA · Cộng Hòa', radius: 200, addr: '235 Cộng Hòa, P.13, Tân Bình, TP.HCM' };
export const FIELD_ADDR = 'KCN VSIP 1, Thuận An, Bình Dương';
export const OFFICE_DIST = 38;
export const PASSKEYS: Array<{ k: string; v: string; me: boolean }> = [
  { k: 'iPhone của DAVID', v: 'đăng ký 02/Oct/2026 · dùng gần nhất 19/Oct', me: true },
  { k: 'Laptop văn phòng', v: 'đăng ký 15/Sep/2026', me: false },
];
export interface HistRow { d: string; dd: string; io: string; note: string; flag: boolean }
export const HIST: HistRow[] = [
  { d: 'T4', dd: '21/Oct', io: '08:21 → 17:36', note: 'trễ 21 phút · khớp mặt 0,52 · gắn cờ để HC–NS xem', flag: true },
  { d: 'T3', dd: '20/Oct', io: '07:52 → 17:41', note: 'Valid · gps-face · 41 m', flag: false },
  { d: 'T2', dd: '19/Oct', io: '07:58 → 18:05', note: 'Valid · passkey · 35 m', flag: false },
];
export const WEEKDAY: Record<string, string> = { T2: 'Thứ Hai', T3: 'Thứ Ba', T4: 'Thứ Tư', T5: 'Thứ Năm', T6: 'Thứ Sáu', T7: 'Thứ Bảy', CN: 'Chủ Nhật' };

/** Ca trong ngày theo lịch công ty (work-calendar): "08:00–11:45 · 13:15–17:30". */
export const shiftLabel = (cal: WorkCalendar, day: string): string => cal.shiftsOf(day).map(([a, b]) => `${hm(a)}–${hm(b)}`).join(' · ');
/** Đi trễ so với giờ vào ca đầu tiên của ngày. */
export const isLate = (cal: WorkCalendar, day: string, t: string): boolean => {
  const first = cal.shiftsOf(day)[0];
  return !!first && Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5)) > first[0];
};
